import devtoolsDetector from 'devtools-detector';
import { useEffect, useState } from 'react';
import config from '../config.json';



const useIsDevToolsOpen = () => {
    const interval = 1000;
    const enabled = config.bIsProd === 'true' ? true : false;


    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (!enabled) return;
        devtoolsDetector.addListener(setIsOpen);
        devtoolsDetector.setDetectDelay(interval);
        devtoolsDetector.launch();
        return () => {
            devtoolsDetector.stop();
            devtoolsDetector.removeListener(setIsOpen);
        };
        // }, []);
    }, [enabled]);


    return isOpen;


};

export default useIsDevToolsOpen;